// extracted by mini-css-extract-plugin
module.exports = {"container":"CardItemSmallList_container__ngn3W"};